module.exports = "/static/assets/afaf48a5bb3b4c64ba0f0cf50b34f0b5.png";